import Vue from 'vue';
import { getToken, destroy } from '@/assets/js/utils/auth';
import { AuthService } from '@/services';

// Apollo GraphQL
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import VueApollo from 'vue-apollo';

Vue.use(VueApollo);

let apolloClientInstance;

function createApolloClient(vueInstance) {
  const httpLink = new HttpLink({
    uri: `${process.env['API-GATEWAY']}/graphql`,
  });
  const authLink = setContext(({ operationName }, { headers }) => ({
    headers: {
      ...headers,
      authorization: getToken(),
      'Accept-Language': vueInstance.$store.getters.lang,
      // https://jira.kiwitaxi.com/browse/DEV-3878
      'X-API-FORBID-LOWERING-TRANSFER-COST': operationName === 'updateTransferOrder' ? 1 : 0,
      // https://jira.kiwitaxi.com/browse/DEV-4256
      ...(vueInstance.$store.getters['$_order/getExperimentRules']),
      ...(vueInstance.$store.getters['$_order/getCouponCode']),
      ...(vueInstance.$store.getters['$_order/getContextLocale']),
    },
  }));
  const apolloError = onError(({ networkError, operation, forward }) => {
    if (networkError && networkError.statusCode === 401) {
      const oldHeaders = operation.getContext().headers;
      const updateContext = () => {
        operation.setContext({
          headers: {
            ...oldHeaders,
            authorization: getToken(),
          },
        });
      };
      const goToLoginPage = () => {
        destroy();
        vueInstance.$router.push('/login');
      };

      return {
        subscribe: ({ next, error, complete }) =>
          AuthService.refresh()
            .then(() => {
              updateContext();
              forward(operation).subscribe(data => {
                next(data);
                complete();
              });
            })
            .catch(() => {
              error();
              goToLoginPage();
            }),
      };
    }
  });
  apolloClientInstance = new ApolloClient({
    link: authLink.concat(apolloError).concat(httpLink),
    cache: new InMemoryCache(),
    connectToDevTools: true,
  });
}

export function getApolloClient() {
  return apolloClientInstance;
}

export default vueInstance => {
  const apolloProvider = new VueApollo({
    defaultClient: createApolloClient(vueInstance),
  });
  return apolloProvider;
};



// WEBPACK FOOTER //
// ./src/apollo.js